import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=b87a17b0&scoped=true&"
import script from "./PaymentInfo.vue?vue&type=script&lang=ts&"
export * from "./PaymentInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentInfo.scss?vue&type=style&index=0&id=b87a17b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87a17b0",
  null
  
)

export default component.exports